import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as me from '../../me'

import { Api } from './api.service'
import { Feature } from './feature'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/** TODO */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  /**
   * Indicates if there are any ongoing processes in the collection.
   *
   * __NOTE:__ Statuses considered on going:
   * - {@link ents.core.relay.processes.Execution.Status.InProgress}
   * - {@link ents.core.relay.processes.Execution.Status.Stopping}
   */
  public readonly hasOngoing

  constructor() {
    const meFeature = ngCore.inject(me.Feature)
    const processesFeature = ngCore.inject(Feature)

    super({
      api: ngCore.inject(Api),
      context$: rxjs
        .combineLatest({
          isOpen: processesFeature.selectors.isSlideoutOpen.asObservable,
          zoneContext: meFeature.contexts.selectors.zoneContext.asObservable,
        })
        .pipe(
          rxjs.map(({ isOpen, zoneContext }) =>
            zoneContext ? { ...zoneContext, isOpen } : undefined,
          ),
        ),
      identify: ({ id }) => id,
      name: ec.Name.Predefined.RelayProcess,
      plugins: {
        additionalFactories: [
          new plugins.ui.Factory(),
          new plugins.polling.Factory(),
        ],
      },
    })

    this.hasOngoing =
      this.plugins.currentListPlugin.feature.selectors.entities.project(
        entities =>
          entities.some(entity =>
            entity.status
              ? [
                  ents.core.relay.processes.Execution.Status.InProgress,
                  ents.core.relay.processes.Execution.Status.Stopping,
                ].includes(entity.status)
              : false,
          ),
      )
  }
}
